import React from 'react';

import { FunctionColor, Preset, Text } from '@lux/text';

import * as S from './styles';

export const Chip: React.FC<React.PropsWithChildren<{ 'aria-selected'?: boolean }>> = ({
    children,
    ...props
}) => {
    const isSelected = props['aria-selected'];

    return (
        <S.Chip $selected={isSelected} {...props}>
            <Text
                preset={Preset.S}
                color={isSelected ? FunctionColor.function0 : FunctionColor.function100}
            >
                {children}
            </Text>
        </S.Chip>
    );
};
